import {EntityService} from '../../../service/EntityService';

export class EmailingService extends EntityService {

  static entity = 'app/emailing';

}
